import { create } from 'zustand';

import { useWorkspaceService } from './useWorkspaceService';

interface WorkspaceSettingDialogState {
    isOpen: boolean;
    workspaceId: string | null;
    open: (workspaceId: string) => void;
    close: () => void;
}

const useWorkspaceSettingDialogStore = create<WorkspaceSettingDialogState>(set => ({
    isOpen: false,
    workspaceId: null,
    open: (workspaceId: string) => set({ isOpen: true, workspaceId }),
    close: () => set({ isOpen: false }),
}));

export const useWorkspaceSettingDialog = () => {
    const { isOpen, workspaceId, open, close } = useWorkspaceSettingDialogStore();
    const { myWorkspaces } = useWorkspaceService();

    const workspace = workspaceId ? myWorkspaces?.find(ws => ws.id === workspaceId) : null;

    return {
        isOpen,
        workspace,
        open,
        close,
    };
};
